<template>
  <form ref="form">
    <b-alert v-if="message.status == 'Error'" show variant="danger">
      <h4 class="alert-heading">{{ $t("general.error") }}</h4>
      <p>{{ errMsg }}</p>
      <hr />
      <p class="mb-0">{{ message.message }}</p>
    </b-alert>
    <b-form-group>
      <b-row>
        <b-col sm="4">
          <label for="accountNo">
            {{ $t("defination.signalProtocols.name") }}
          </label>
        </b-col>
        <b-col sm="8">
          <b-form-input
            id="accountNo"
            v-model="name"
            :placeholder="$t('defination.signalProtocols.name')"
        /></b-col>
      </b-row>
    </b-form-group>
  </form>
</template>

<script>
export default {
  name: "Protocols",
  data: function() {
    return {
      errMsg: "",
      name:this.data ? this.data.name : ""
    };
  },
  props: {
    data: Object,
    changeData: Function,
    save: Boolean,
    saveState: Function,
    modalName: String,
    modalEvent: Function
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    clearForm() {
      this.name = "";
      this.errMsg = "";
      this.modalEvent(false);
    }
  },
  computed: {
    message() {
      return this.$store.getters.getStatus;
    },
  },
  watch: {
    save: async function(data) {
      if (data) {
        let val = {
          name:this.name
        }
        switch (this.modalName) {
          case "add":
            await this.$store.dispatch("addProtocols", val);
            break;
          case "edit":
            val.id = this.data.id;
            await this.$store.dispatch("editProtocols", val);
            break;
        }
        if (this.$store.getters.getAddressStatus.status == "Success") {
          this.$store.dispatch("signalprotocol_list");
          this.clearForm();
        } else {
          this.errMsg = i18n.t("general.addErrMsg");
        }
      }
      this.saveState(false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/General/Defination/modals/Protocol.vue